// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container mat-divider {
  margin-bottom: 2rem;
}
.main-container mat-divider:first-of-type {
  margin: 2rem 0;
}
.main-container p {
  text-align: justify;
  color: var(--text-color);
}
.main-container ul li {
  list-style-type: none;
  font-size: medium;
}
.main-container h1 {
  font-size: 250%;
  text-align: center;
  color: var(--text-color);
}
.main-container h2 {
  color: var(--text-color);
}
.main-container img {
  width: 100%;
  border-radius: 5px;
  margin-top: 0;
  margin-bottom: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/about-us/about-us.component.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;AAAJ;AAEI;EACE,cAAA;AAAN;AAIE;EACE,mBAAA;EACA,wBAAA;AAFJ;AAKE;EACE,qBAAA;EACA,iBAAA;AAHJ;AAME;EACE,eAAA;EACA,kBAAA;EACA,wBAAA;AAJJ;AAOE;EACE,wBAAA;AALJ;AAQE;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AANJ","sourcesContent":[".main-container {\r\n  mat-divider {\r\n    margin-bottom: 2rem;\r\n\r\n    &:first-of-type {\r\n      margin: 2rem 0;\r\n    }\r\n  }\r\n\r\n  p {\r\n    text-align: justify;\r\n    color: var(--text-color);\r\n  }\r\n\r\n  ul li {\r\n    list-style-type: none;\r\n    font-size: medium;\r\n  }\r\n\r\n  h1 {\r\n    font-size: 250%;\r\n    text-align: center;\r\n    color: var(--text-color);\r\n  }\r\n\r\n  h2{\r\n    color: var(--text-color);\r\n  }\r\n\r\n  img {\r\n    width: 100%;\r\n    border-radius: 5px;\r\n    margin-top: 0;\r\n    margin-bottom: 2rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
